module.exports = __webpack_public_path__ + "static/Icons_CurrentHO_ReverseMortgage_Large-a2ca83db4f21c7f6a4923bad35e53f42.png";